import type { ComponentProps } from "react";

import { cn } from "@/utils/cn";

export const FormCard = ({ className, children, ...rest }: ComponentProps<"section">) => (
  <section
    className={cn(
      "rounded-2xl border border-zinc-200 bg-white p-4 shadow-sm sm:rounded-3xl sm:p-6",
      className,
    )}
    {...rest}
  >
    {children}
  </section>
);
